import React, { useEffect, useState } from "react";
import MagicLink from "../MagicLink";
import { useDispatch, useSelector } from "react-redux";
import LinksContainer from "./LinksContainer";
import {
    closeSectionCreateModal,
    closeSectionDeleteModal,
    closeSectionPickModal,
    openSectionCreateModal,
    setLinksChanged,
    setMagicLinkInput,
    setNonStoreSectionsChanged
} from "../../../redux/slice/dashboardSlice";
import SortableList from "./SortableList";
import { arrayMoveImmutable } from "array-move";
import { deleteSection, findDiff } from "../../Builder/builderServices/utils";
import ShareModal from "../../Wall3/Store/ShareBottomSheet";
import { message } from "antd";
import Modal from "../../common/ModalV2/Modal";
import styles from "./index.module.css";
import {
    addLinkToNonStoreSection,
    addLinkToNonStoreSectionsWrapper,
    addNewLinkWithNewNonStoreSection,
    addNewLinkWithNewStoreSection
} from "../../../Services/apiServices/linkService";
import AddSection from "../AddSection";
import rightArrow from "../../../assets/icons/mobileIcons/rightArrow.png";
import { vibrateDevice } from "../utils";

const index = () => {
    const dispatch = useDispatch();
    const {
        nonStoreSectionsChanged,
        isSectionPickModalOpen,
        magicLinkResponse,
        nonStoreAddedTemplateType,
        isSectionDeleteModalOpen,
        isSectionCreateModalOpen
    } = useSelector((state) => state.root.dashboard);
    const [list, setList] = useState(nonStoreSectionsChanged);
    const [title, setTitle] = useState("");

    const onSortStart = () => {
        vibrateDevice(80);
    };

    const onSortEnd = ({ oldIndex, newIndex }) => {
        setList(arrayMoveImmutable(list, oldIndex, newIndex));
        let nonStoreSectionsChangedCopy = [...nonStoreSectionsChanged];
        let tempSortId = nonStoreSectionsChangedCopy[newIndex].sortId;
        if (newIndex > oldIndex) {
            nonStoreSectionsChangedCopy = nonStoreSectionsChangedCopy.map((section, i) => {
                if (i > oldIndex && i <= newIndex) {
                    return {
                        ...section,
                        sortId: nonStoreSectionsChangedCopy[i - 1].sortId
                    };
                }
                return section;
            });
        } else if (oldIndex > newIndex) {
            nonStoreSectionsChangedCopy = nonStoreSectionsChangedCopy.map((section, i) => {
                if (i >= newIndex && i < oldIndex) {
                    return {
                        ...section,
                        sortId: nonStoreSectionsChangedCopy[i + 1].sortId
                    };
                }
                return section;
            });
        }
        nonStoreSectionsChangedCopy[oldIndex] = {
            ...nonStoreSectionsChangedCopy[oldIndex],
            sortId: tempSortId
        };
        const item = nonStoreSectionsChangedCopy.splice(oldIndex, 1)[0];
        nonStoreSectionsChangedCopy.splice(newIndex, 0, item);
        dispatch(setNonStoreSectionsChanged(nonStoreSectionsChangedCopy));
        dispatch(setLinksChanged());
        findDiff();
    };

    useEffect(() => {
        setList(nonStoreSectionsChanged);
    }, [nonStoreSectionsChanged]);

    return (
        <div className={styles.container}>
            <MagicLink screen="LinkInBio" />
            <SortableList items={list} onSortStart={onSortStart} onSortEnd={onSortEnd} pressDelay={1000} lockAxis="y" />

            <Modal
                showModal={isSectionPickModalOpen}
                alignItems={"center"}
                onClose={() => {
                    dispatch(closeSectionPickModal(false));
                    dispatch(setMagicLinkInput(""));
                }}
            >
                <div className={styles.sectionsListModal}>
                    <div className={styles.sectionsListHeading}>Add link to section</div>
                    <div className={styles.sectionsList}>
                        {nonStoreSectionsChanged.map((e, i) => {
                            return (
                                <div
                                    className={styles.sectionsListItem}
                                    key={i}
                                    onClick={() => {
                                        addLinkToNonStoreSection(e, magicLinkResponse);
                                        dispatch(closeSectionPickModal());
                                    }}
                                >
                                    <div className={styles.sectionsListItemTitle} key={i}>
                                        {e?.title}
                                    </div>
                                    <img className={styles.sectionsListItemArrow} src={rightArrow}></img>
                                </div>
                            );
                        })}
                    </div>
                    <div className={styles.addSection} onClick={() => dispatch(openSectionCreateModal())}>
                        + Add Section
                    </div>
                </div>
            </Modal>
            {isSectionCreateModalOpen && (
                <AddSection
                    onClose={() => {
                        dispatch(closeSectionCreateModal());
                    }}
                    onConfirm={(title) => {
                        if (title.length > 0) {
                            addNewLinkWithNewNonStoreSection(title);
                            message.success("Added link to New Section");
                        } else {
                            message.info("Section Title is empty");
                        }
                        dispatch(closeSectionCreateModal());
                    }}
                />
            )}
            <ShareModal />
        </div>
    );
};

export default index;
